export const SUBSCRIBE = '/.netlify/functions/subscribe';
export const CONTACT = '/.netlify/functions/contact';
